// extracted by mini-css-extract-plugin
module.exports = {"container":"_a64af95f"};